import { arrayMove } from '@dnd-kit/sortable'
import type { Transform } from '@dnd-kit/utilities'
import type { BlockWireframe } from '@octopus-do/octopus-project-core'

// A block may hold the same wireframe twice, so a row is identified by its
// position as well.
export const wireframeItemId = (wireframe: BlockWireframe, index: number) =>
  `${wireframe}-${index}`

export const moveWireframe = (
  wireframes: BlockWireframe[],
  from: number,
  to: number
): BlockWireframe[] => arrayMove(wireframes, from, to)

// By position, not by variant: the same wireframe may sit in the block twice.
export const removeWireframe = (
  wireframes: BlockWireframe[],
  index: number
): BlockWireframe[] => wireframes.filter((_, i) => i !== index)

// dnd-kit measures in screen pixels while the rows live inside the scaled
// canvas: a row moves only along the list, by the pointer distance in canvas
// pixels. The dragged row keeps its size: dnd-kit scales it to the row under
// the pointer for a DragOverlay to undo, and there is none here.
export const toCanvasTransform = (
  transform: Transform,
  scale: number
): Transform => ({
  x: 0,
  y: transform.y / scale,
  scaleX: 1,
  scaleY: 1,
})
